import type { PayloadAction } from '@reduxjs/toolkit';
import type { ModalInitialStateType, ModalPropTypes } from 'src/helper/shared-types';

type PayloadType = {
  modalType: keyof ModalInitialStateType;
  isVisible: boolean;
  extraProps?: ModalPropTypes;
};

const reducers = {
  updateVisibility: (state: ModalInitialStateType, action: PayloadAction<PayloadType>) => {
    state[action.payload.modalType].isVisible = action.payload.isVisible;
    state[action.payload.modalType].extraProps = action.payload.extraProps;
  },
  updateCommonModalLoadingState: (
    state: ModalInitialStateType,
    action: PayloadAction<ModalPropTypes['buttonLoading']>,
  ) => {
    const newCommonModal = {
      ...state.commonModal,
      extraProps: {
        ...(state.commonModal?.extraProps ?? {}),
        buttonLoading: action.payload,
      },
    };
    state.commonModal = newCommonModal;
  },
  updateConfirmationLoadingState: (
    state: ModalInitialStateType,
    action: PayloadAction<ModalPropTypes['buttonLoading']>,
  ) => {
    const newConfirmationModal = {
      ...state.confirmationModal,
      extraProps: {
        ...(state.confirmationModal?.extraProps ?? {}),
        buttonLoading: action?.payload,
      },
    };
    state.confirmationModal = newConfirmationModal;
  },

  updateCommonDeleteModalLoadingState: (
    state: ModalInitialStateType,
    action: PayloadAction<ModalPropTypes['buttonLoading']>,
  ) => {
    const newCommonDeleteModal = {
      ...state.commonDeleteModal,
      extraProps: {
        ...(state.commonDeleteModal?.extraProps ?? {}),
        buttonLoading: action?.payload,
      },
    };
    state.commonDeleteModal = newCommonDeleteModal;
  },

  updateWorkOrderActionModalLoadingState: (
    state: ModalInitialStateType,
    action: PayloadAction<ModalPropTypes['buttonLoading']>,
  ) => {
    const newUpdateActionModal = {
      ...state.workOrderActions,
      extraProps: {
        ...(state.workOrderActions?.extraProps ?? {}),
        buttonLoading: action?.payload,
      },
    };
    state.workOrderActions = newUpdateActionModal;
  },

  updateDualModalLoadingState: (
    state: ModalInitialStateType,
    action: PayloadAction<ModalPropTypes['buttonLoading']>,
  ) => {
    const newUpdateActionModal = {
      ...state.dualActionModal,
      extraProps: {
        ...(state.dualActionModal?.extraProps ?? {}),
        buttonLoading: action?.payload,
      },
    };
    state.dualActionModal = newUpdateActionModal;
  },

  updateQuoteMaterialModalLoadingState: (
    state: ModalInitialStateType,
    action: PayloadAction<ModalPropTypes['buttonLoading']>,
  ) => {
    const newUpdateActionModal = {
      ...state.addEditQuoteMaterialModal,
      extraProps: {
        ...(state.addEditQuoteMaterialModal?.extraProps ?? {}),
        buttonLoading: action?.payload,
      },
    };
    state.addEditQuoteMaterialModal = newUpdateActionModal;
  },
};

export default reducers;
